import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-2 w-full px-10 lg:gap-40" }
const _hoisted_2 = { class: "flex flex-col items-start justify-start w-full my-4 text-left self-start" }

import { ref } from 'vue';
import ContactMeForm from '@/features/components/ContactMe/ContactMeForm.vue';
import BaseCard from '@/features/global/BaseCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactMe',
  setup(__props) {

const submitted = ref(false);
const toggleSubmitted = (): void => {
    submitted.value = !submitted.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'Contact Me',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex flex-col items-center justify-between w-full" }, [
          _createElementVNode("h2", null, "Find Me Here!"),
          _createElementVNode("div", { class: "mt-4" }, [
            _createElementVNode("span", { class: "contact-icons flex justify-center mb-12 lg:mb-25 overflow-visible gap-[calc(8vw+10px)]" }, [
              _createElementVNode("a", {
                href: "https://www.linkedin.com/in/clairangelgreen/",
                target: "_blank",
                alt: "My LinkedIn!"
              }, [
                _createElementVNode("i", { class: "fa-brands fa-linkedin" })
              ]),
              _createElementVNode("a", {
                href: "https://github.com/cgreen2048",
                target: "_blank",
                alt: "My Github!"
              }, [
                _createElementVNode("i", { class: "fa-brands fa-github" })
              ])
            ]),
            _createElementVNode("span", { class: "contact-icons mb-4 lg:mb-25" }, [
              _createElementVNode("a", {
                href: "mailto: bgreen8@nd.edu?subject=Email%20From%20Website",
                alt: "Email me at bgreen8@nd.edu!"
              }, [
                _createElementVNode("i", { class: "fa-solid fa-envelope" })
              ]),
              _createElementVNode("a", {
                href: "/files/ClairGreenResume.pdf",
                download: "ClairGreenResume.pdf",
                alt: "Download my resume!"
              }, [
                _createElementVNode("i", { class: "fa fa-file-pdf-o" })
              ])
            ])
          ])
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col items-center w-full", submitted.value ? 'justify-center' : 'justify-between'])
        }, [
          _createElementVNode("h2", {
            class: _normalizeClass(["text-center", { 'hidden': submitted.value }])
          }, " Or Contact Me Directly: ", 2),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ContactMeForm, {
              submitted: submitted.value,
              onToggleSubmitted: toggleSubmitted
            }, null, 8, ["submitted"])
          ])
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})